exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-banner-container[data-v-25dfda1a] {\n  padding: 20px;\n}", ""]);

// exports
